import { z } from "zod";
export const RegisterSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(128),
    displayName: z.string().min(1).max(100).transform((s) => s.trim()),
});
export const InviteRegisterSchema = RegisterSchema.extend({
    inviteCode: z.string().min(1),
});
export const LoginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
//# sourceMappingURL=auth.js.map